import React, { useEffect, PropsWithChildren } from "react";

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { SelectBox } from "@/components/holders/SelectBox";
import { ArrowLongRightIcon } from '@heroicons/react/24/outline'
import { TimeBox } from "@/components/holders/TimeBox";
import { Calender } from "@/components/holders/Calender";
import {Label, Popover} from 'react-aria-components';

interface Props extends PropsWithChildren<any>{
   sectors: any,
   onChange: Function,
   data: Object
}

interface MyComponentProps {
  children: React.ReactNode;
}

export function SectorSelect(props: Props) {
   const [registrationItem, setRegistrationItem] = useState((props?.data) ? {...props.data} : {sector_key: null, department_key: null});
   const [departments, setDepartments] = useState([]);



    if( (typeof registrationItem['sector_key']) == 'string' && props?.sectors && departments.length == 0) {
        let sectors = props?.sectors.items;
        for(let i in sectors) {
            if(sectors[i]['key'] == registrationItem['sector_key']) {
                
                //departments = props.sectors[i]['children'];
               setDepartments(sectors[i]['children']['items']);
                
            }
        }
    }

   const changeSectorEventHandler = (name, val) => {
       let departmentSelector = [];
       
       if(val) {
           //departmentSelector.push( createDepartmentSelector(val.id, val.children, "") );
           if(val?.key) {
           departmentSelector = val.children;
           setDepartments(departmentSelector);
           registrationItem['sector_key'] = {key: val.key, name: val.name};
           registrationItem['department_key'] = null;
           
           if(props.onChange) {
              props.onChange({item: registrationItem, fields: ['sector_key', 'department_key']}); 
           }
           }
       }
       //setValueCombobox(name, val);
   }
   const setValueCombobox= (name, selected) => {
       if(selected) {
           registrationItem[name] = {key: selected.key, name: selected.name};
           setRegistrationItem(registrationItem);

           if(props.onChange) {
              props.onChange({item: registrationItem, fields: ['sector_key', 'department_key']});
           }
       }
   }
   
   
       

    
    return (
        <>
        <div className={props?.className} >
        <div className="sm:col-span-12">
            <Label className="text-black cursor-default text-sm font-medium leading-6 text-gray-900">{props?.header}</Label>            
            <SelectBox key="sector_key" className=""  name="organisation_sector" data={props?.sectors}
            selected={registrationItem['sector_key']} changeEvent={(name, selectedSector) => changeSectorEventHandler(name, selectedSector)} boxfield="name"  placeHolder="Selecteer een organisatie sector"/>
        </div>

        {registrationItem['sector_key'] && 
                <div className="sm:col-span-12">
                    <SelectBox key={((registrationItem['department_key']) ? registrationItem['department_key']['key'] : registrationItem['key'])} parentKey={registrationItem['sector_key']['key']} className=""  name="department_key"  placeHolder="Selecteer eerst de sector" disabled={(!registrationItem['sector_key'])} data={departments} selected={registrationItem['department_key']} boxfield="name" changeEvent={(name, val) => setValueCombobox(name,val)}/>
                </div>
                }


                </div>
</>
        );
}
